module.exports = __webpack_public_path__ + "assets/carvebg-4204c1613fa73497c8652c7f21bfc4c1.png";


//////////////////
// WEBPACK FOOTER
// ./button/libs/mfButtons/images/carvebg.png
// module id = 55
// module chunks = 4